import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as EMRIcon } from "../Icons/vuesax/direct-normal.svg";
import { ReactComponent as FileUploadIcon } from "../Icons/vuesax/document-upload.svg";
import { ReactComponent as GraphIcon } from "../Icons/vuesax/graph.svg";
import { ReactComponent as PeopleIcon } from "../Icons/vuesax/people.svg";
import { ReactComponent as InfoIcon } from "../Icons/vuesax/Info.svg";
import { ReactComponent as DocumentTextIcon } from "../Icons/vuesax/document-text.svg";
import { PermissionsContext } from "../permission-context";

function Home() {
  const { hasPermission } = useContext(PermissionsContext);
  const navigate = useNavigate();
  const paperStyle = {
    width: "174px",
    height: "135px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  };

  const textStyle = {
    mt: 1,
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "15.62px",
    textAlign: "center",
  };

  return (
    <>
      <Grid container justifyContent='center' alignItems='center' sx={{ marginTop: "25px" }}>
        <Grid container spacing={3} sx={{ margin: "16px", width: "80vw" }}>
          {hasPermission("EMR") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper elevation={3} sx={paperStyle} onClick={() => navigate("/emrentry")}>
                <EMRIcon />
                <Typography sx={textStyle}>EMR Entry</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("PatientVisits") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper
                elevation={3}
                sx={paperStyle}
                onClick={() => navigate("/wci-ortho-surgery-visit")}>
                <FileUploadIcon />
                <Typography sx={textStyle}>WCI OrthoSurgery Visits Update</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("PatientVisits") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper
                elevation={3}
                sx={paperStyle}
                onClick={() => navigate("/core-schedule-importer")}>
                <FileUploadIcon />
                <Typography sx={textStyle}>CoreSchedule Importer</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("MER") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper elevation={3} sx={paperStyle} onClick={() => navigate("/mrr-documents")}>
                <FileUploadIcon />
                <Typography sx={textStyle}>MRR Documents</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("ViewVScribeAiPhoneDictStatus") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper
                elevation={3}
                sx={paperStyle}
                onClick={() => navigate("/phone-dictation-status")}>
                <GraphIcon />
                <Typography sx={textStyle}>Client Dictation Status</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("AppDeviceInfo") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper elevation={3} sx={paperStyle} onClick={() => navigate("/device-info")}>
                <InfoIcon />
                <Typography sx={textStyle}>App Device Information</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("AppNotificationLogs") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper
                elevation={3}
                sx={paperStyle}
                onClick={() => navigate("/app-notification-logs")}>
                <DocumentTextIcon />
                <Typography sx={textStyle}>App Notification Logs</Typography>
              </Paper>
            </Grid>
          )}

          {hasPermission("Admin") && (
            <Grid size={{ xs: 6, md: 3 }} container justifyContent='center' alignItems='center'>
              <Paper elevation={3} sx={paperStyle} onClick={() => navigate("/manage-users")}>
                <PeopleIcon />
                <Typography sx={textStyle}>Manage Users</Typography>
              </Paper>
            </Grid>
          )}
        </Grid>

        {!hasPermission("EMR") &&
          !hasPermission("PatientVisits") &&
          !hasPermission("Admin") &&
          !hasPermission("ViewVScribeAiPhoneDictStatus") &&
          !hasPermission("AppDeviceInfo") &&
          !hasPermission("AppNotificationLogs") && (
            <h1>You do not have permission to view this page. Please contact the administrator.</h1>
          )}
      </Grid>
    </>
  );
}

export default Home;
